import config from './config'

/**
 *
 * @param {*key} field
 * @param {*value} value
 */
const onChange = (self, field, value) => {
    self.setState({
        [field]: value,
    });
}

const formatTime = date => {

    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}
/**
 * 对象是否为空
 * @param obj
 * @returns {boolean}
 */
const isEmpty = obj =>{
    if (typeof obj !== 'object') return;
    for (let i in obj) {
        return false;
    }
    return true;
}
//去除空格
function Trim(str) {
    if(!str || str == ""){
        return;
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
}
/**
 * 获取路径参数
 */
function getUrlParam(url) {
    if (typeof url === 'undefined') {
        url = window.location.href;
    }
    if (url.indexOf("?") === -1) {
        return {};
    }
    var paraString = url.substring(url.lastIndexOf("?") + 1, url.length).split("&"),
        paraObj = {};
    var i, j;
    for (i = 0; j = paraString[i]; i++) {
        var key = j.substring(0, j.indexOf("=")).toLowerCase();
        var value = j.substring(j.indexOf("=") + 1, j.length);
        value = value ? value.split("#")[0] : "";
        paraObj[key] = decodeURIComponent(value);
    }
    return paraObj;
}
//数字大写转换
const digitUppercase = function(n) {
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '负' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
}
//手机号 131 4592 7887
function mobileNumber(number) {
    var a='';
    if(number){
        a = number
        number = number.replace(/\s/g, "");//去除掉所有的空格
        number = number.split('');//字符串转换成数组
        var zzz=[];
        if(parseInt(number.length) == 11){
            for(var i=0; i<number.length; i++){
                if((i+1) == 3){
                    zzz.push(number[i]+" ")
                }else if((i+1-3)%4 == 0){
                    zzz.push(number[i]+" ")
                }else{
                    zzz.push(number[i])
                }
            }
            zzz = zzz.join('')
            return zzz;
        }else{
            return a;
        }
    }
}

// 验证规则 注册
const validator = (rule, value, callback) => {
    if (!value) {
        callback()
        return
    }
    if ( !rule.pattern.test(value.replace(/\s/g, '')) ) {
        callback(rule.message)
    }
    callback()
}

/**
 * 判断浏览器版本
 * @returns {*}  -1，不是ie浏览器。11，IE11。
 * @constructor
 */
function IEVersion() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if(isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if(fIEVersion == 7) {
            return 7;
        } else if(fIEVersion == 8) {
            return 8;
        } else if(fIEVersion == 9) {
            return 9;
        } else if(fIEVersion == 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }
    } else if(isEdge) {
        return 'edge';//edge
    } else if(isIE11) {
        return 11; //IE11
    }else{
        return -1;//不是ie浏览器
    }
}

/**
 * 获取字符串长度，中文+2
 */
function getStringLength(str) {
    if (!str || typeof str !== 'string') {
        return 0
    }
    return str.replace(/[^\x00-\xff]/g, '01').length
}

/**
 * antd Form Validator
 * 字符长度校验，中文按2位计算，并且判断是否为required
 * @param  {Number}   length   最大长度
 * @param  {Number}   min      最小长度
 * @param  {Object}   rule     原validator rule
 * @param  {String}   value    原validator value
 * @param  {Function} callback 原validator callback
 */
function validateStringLength(rule, value, callback) {
    if ((rule.required && !Trim(value)) || (rule.length && getStringLength(value) > rule.length)
        || (rule.min && getStringLength(value) < rule.min)) {
        callback(rule.message)
    }
    callback()
}

function uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
    } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random()*16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return uuid.join('');
}

/**
 * 根据域名获取appid
 */
function getAppid() {
    if (location.hostname === 'shanghu.wetax.com.cn') {
        return config.yunpiaoAppid
    }
    // 线上环境
    if (location.hostname === 'shanghu.fapiaoer.cn') {
        return config.appid
    }
    // 测试环境
    if (location.hostname === 'shanghu-dev.fapiaoer.cn') {
        return config.devAppid
    }
}

/**
 * 合并数组并去重
 * @param  {Array} args 需要合并的数组
 * @return {Array}         返回合并后的数组
 */
export function concatArray(...args) {
    const arr = Array.prototype.concat.apply([], args)
    return Array.from(new Set(arr))
}

/**
 * urlToList
 * /userinfo/2144/id => ['/userinfo', '/useinfo/2144', '/userindo/2144/id']
 * @param  {String} url
 * @return {Array}
 */
export function urlToList(url) {
    const urls = url.split('/').filter(i => i)
    return urls.map((urlItem, index) => `/${urls.slice(0, index + 1).join('/')}`)
}

export default {
    onChange,
    formatTime,
    isEmpty,
    Trim,
    digitUppercase,
    getUrlParam,
    mobileNumber,
    validator,
    IEVersion,
    getStringLength,
    validateStringLength,
    uuid,
    getAppid,
    concatArray,
    urlToList
}
